import axios from 'axios';
import { get, isArrayBuffer, get as lodashGet } from 'lodash';
import { ajaxEnd, ajaxFail, ajaxStart, ajaxSuccess } from 'store/actions/ajax';

import configs from 'configs';

const AJAX_TIMEOUT = 58000;
const BASE_URL = configs.host;
const AJAX_END_TIMEOUT = 700;

const arraybufferToJson = (arraybuffer) => {
    try {
        const str = String.fromCharCode.apply(null, new Uint8Array(arraybuffer));
        const json = JSON.parse(str);
        return json;
    } catch (e) {
        return undefined;
    }
};

let reduxStore;
export function initAxiosClient(store) {
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    reduxStore = store;
}
export function liffAuthAxiosClient(token) {
    axios.defaults.headers.common['x-access-token'] = token;
}
// export function authAxiosClient(token) {
//     axios.defaults.headers.common['x-access-token'] = token;
// }
// export function initAuthAxiosClient() {
//     axios.defaults.headers.common['Authorization'] = undefined;
// }

export function getAxiosClient(
    storeKey = '',
    opt = {
        isAdminPath: true,
        passthrough: undefined,
        hideError: false,
        hideLoading: false
    }
) {
    const { hideError, hideLoading } = opt;
    const headers = {
        'Content-Type': 'application/json'
    };

    const axiosClient = axios.create({
        baseURL: `${BASE_URL}${get(opt, 'isAdminPath', true) ? configs.adminPath : ''}`,
        timeout: AJAX_TIMEOUT,
        headers
    });

    axiosClient.interceptors.request.use(
        (config) => {
            if (!hideLoading) reduxStore.dispatch(ajaxStart(storeKey));
            return config;
        },
        (err) => {
            return Promise.reject(err);
        }
    );

    axiosClient.interceptors.response.use(
        (res) => {
            if (!hideLoading) {
                // setTimeout(() => {
                //   reduxStore.dispatch(ajaxEnd(storeKey));
                // }, AJAX_END_TIMEOUT);
            }

            if (storeKey) {
                reduxStore.dispatch(ajaxSuccess(storeKey, res.data));
            }
            if (opt.passthrough && opt.passthrough instanceof Function) {
                reduxStore.dispatch(opt.passthrough(res.data));
            }
            return res;
        },
        (err) => {
            const defaultMessage = 'Network Issue';
            // capture error object to fulfill all error condition
            let errorData = lodashGet(err, ['response', 'data']);
            if (isArrayBuffer(errorData)) {
                errorData = arraybufferToJson(errorData);
            }
            const error = lodashGet(errorData, 'err', defaultMessage);

            if (!hideError) {
                // show error message banner
            }

            if (!hideLoading) {
                setTimeout(() => {
                    reduxStore.dispatch(ajaxEnd(storeKey));
                }, AJAX_END_TIMEOUT);
            }

            // Authentication module force logout if status code == 401
            // if (err.response && err.response.status === 401) {
            //     if (err.config.headers.Authorization) reduxStore.dispatch(logoutClient);
            // }

            if ((storeKey, !hideError)) {
                reduxStore.dispatch(ajaxFail(storeKey));
            }

            throw err;
        }
    );

    return axiosClient;
}
